import { VulnerabilityField } from 'modules/cm/Vulnerabilities/Vulnerability';
import { Vulnerability as ApiVulnerability } from '../Vulnerability';
import { Vulnerability as DomainVulnerability } from 'modules/cm/Vulnerabilities/Vulnerability';
import { format } from 'utils/date';

const mapVulnerability = (apiVulnerability: ApiVulnerability): DomainVulnerability => ({
  id: apiVulnerability.id,
  [VulnerabilityField.Category]: apiVulnerability.category,
  [VulnerabilityField.DateOfConsent]: apiVulnerability.dateOfConsent
    ? format(apiVulnerability.dateOfConsent).fromBackendToView()
    : null,
  [VulnerabilityField.DateRecorded]: format(apiVulnerability.dateRecorded).fromBackendToView(),
  [VulnerabilityField.CommentsAndAdditionalInformation]: apiVulnerability.commentsAndAdditionalInformation,
  [VulnerabilityField.InformationProvidedBy]: apiVulnerability.informationProvidedBy,
  [VulnerabilityField.IsAppropriateForExplicitConsent]: apiVulnerability.isAppropriateForExplicitConsent,
  [VulnerabilityField.IsExplicitConsentFromCustomer]: apiVulnerability.isExplicitConsentFromCustomer,
});

export default mapVulnerability;
